import QuantityConversion from './QuantityConversion';
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';
import { MathFormula } from './Math';

export class QuantityDeterminationService {

    static response = {
        CorrectedVolumeTextBox: "",
        VCFTextbox: "",
        WeightTextBox: "",
        MassLabel: "",
        WCFTextBox: "",


    };
    ;
    static QuantityDetermination(config, PressureCorrectionCheckBox, m3RadioButtonChecked) {
        ;
        const conversion = new QuantityConversion();
        conversion.Commodity = parseFloat(config.Commodity);
        //Gravity Details
        conversion.ObservedGravityValue = config.ObservedGravityValue;
        conversion.ObservedGravityType = parseFloat(config.ObservedGravityType);
        conversion.ObservedGravityTemperature = config.ObservedGravityTemperature;
        conversion.ObservedGravityTemperatureUnit = parseFloat(config.ObservedGravityTemperatureUnit);
        if (!PressureCorrectionCheckBox) {
            conversion.ObservedGravityPressure = config.ObservedGravityPressure;
            conversion.ObservedGravityPressureUnit = parseFloat(config.ObservedGravityPressureUnit);
        }

        //'Volume Details'
        conversion.ObservedQuantityValue = config.ObservedQuantityValue;
        conversion.ObservedQuantityUnit = parseFloat(config.ObservedQuantityUnit);
        conversion.ObservedQuantityTemperature = config.ObservedQuantityTemperature;
        conversion.ObservedQuantityTemperatureUnit = parseFloat(config.ObservedQuantityTemperatureUnit);
        if (!PressureCorrectionCheckBox) {
            conversion.ObservedQuantityPressure = config.ObservedQuantityPressure;
            conversion.ObservedQuantityPressureUnit = parseFloat(config.ObservedQuantityPressureUnit);
        }

        //'Calculate Corrected Volume'
        if (m3RadioButtonChecked) {
            conversion.AlternateQuantityUnit = VpsQuantityUnit.CubicMetres;
        }
        else {
            conversion.AlternateQuantityUnit = VpsQuantityUnit.Barrels;
        }
        conversion.AlternateQuantityTemperature = config.BaseTemperatureValue;
        conversion.AlternateQuantityTemperatureUnit = parseFloat(config.BaseTemperatureUnit);
        if (!PressureCorrectionCheckBox) {
            conversion.AlternateQuantityPressure = config.BasePressureValue;
            conversion.AlternateQuantityPressureUnit = parseFloat(config.BasePressureUnit);
        }
        if (!conversion.Exception) {
            conversion.ConvertQuantity();
            if (!conversion.Exception) {
                if (m3RadioButtonChecked) {
                    QuantityDeterminationService.response.CorrectedVolumeTextBox = parseFloat(RoundValueASTM(conversion.CubicMetres, 0.001)).toFixed(3); //3
                } else {
                    QuantityDeterminationService.response.CorrectedVolumeTextBox = parseFloat(RoundValueASTM(conversion.Barrels, 0.001)).toFixed(3); //3
                }
                QuantityDeterminationService.response.VCFTextbox = parseFloat(conversion.VolumeConversionFactor).toFixed(5);  //1

            }
            conversion.AlternateQuantityUnit = VpsQuantityUnit.MetricTons;
            conversion.AlternateQuantityTemperature = "";
            conversion.AlternateQuantityTemperatureUnit = null;
            conversion.AlternateQuantityPressure = "";
            conversion.AlternateQuantityPressureUnit = null;
            conversion.ConvertQuantity()
            if (!conversion.Exception) {
                QuantityDeterminationService.response.WeightTextBox = parseFloat(conversion.MetricTons).toFixed(3); //4
                QuantityDeterminationService.response.MassLabel = parseFloat(conversion.Mass_MT).toFixed(3); //5
                QuantityDeterminationService.response.WCFTextBox = parseFloat(conversion.WeightFactor).toFixed(1); //2
                return QuantityDeterminationService.response;
                
            }

        }
    }

}
